import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex mt-3 mb-2"
}
const _hoisted_2 = { class: "flex-fill min-width-0 pl-2" }

import InlineSelect from "~/core-ui/vue/ui/InlineSelect.vue";
import {computed} from "vue";
import useTextareaComponent from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";
import {__} from "~/ts/library/Translate";



import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "AnswerChannelSourceSelect"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let {site, model, selectedAnswerChannel} = useTextareaComponent();

let answerChannelSourceIds = computed(() => {
    let result: OperatorApplicationApi.OperatorGetParamsSiteAnswerChannelSourceIdOpenApiModel[] = [];
    if (site.value) {
        result = site.value.answerChannelSourceIds.filter(source => source.answerChannelId === model.value.answerChannelId);
    }
    if (!result.find(item => item.id == model.value.answerChannelSourceId)) {
        if (result.length) {
            model.value.answerChannelSourceId = result[0].id;
        } else {
            model.value.answerChannelSourceId = null;
        }
    }
    return result;
});

return (_ctx: any,_cache: any) => {
  return (_unref(selectedAnswerChannel) && _unref(selectedAnswerChannel).hasSource && _unref(answerChannelSourceIds).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, _toDisplayString(_unref(__)('От')) + ":", 1),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(InlineSelect, {
            modelValue: _unref(model).answerChannelSourceId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).answerChannelSourceId) = $event)),
            placeholder: _unref(__)('Выберите имя отправителя'),
            options: _unref(answerChannelSourceIds).map(source => ({ value: source.id, label: source.descr }))
          }, null, 8, ["modelValue", "placeholder", "options"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})